// src/shared/store/themeStore.ts

import { create } from 'zustand';

type ThemeState = {
  theme: 'light' | 'dark';
  toggleTheme: () => void;
};

const getInitialTheme = (): 'light' | 'dark' => {
  if (typeof window !== 'undefined') {
    const storedTheme = localStorage.getItem('theme');
    if (storedTheme === 'light' || storedTheme === 'dark') {
      return storedTheme;
    }
    const prefersDark = window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches;
    return prefersDark ? 'dark' : 'dark';
  }
  return 'dark'; // Default theme if window is undefined
};

export const useThemeStore = create<ThemeState>((set) => {
  const initialTheme = getInitialTheme();

  // Set the data-theme attribute on the body
  if (typeof document !== 'undefined') {
    document.body.setAttribute('data-theme', initialTheme);
  }

  return {
    theme: initialTheme,
    toggleTheme: () =>
      set((state) => {
        const newTheme = state.theme === 'light' ? 'dark' : 'light';
        if (typeof window !== 'undefined') {
          localStorage.setItem('theme', newTheme);
          document.body.setAttribute('data-theme', newTheme);
        }
        return { theme: newTheme };
      }),
  };
});
